export const appStoreUrls = {
  iOS: "https://apps.apple.com/jp/app/id6477852874",
  android: "https://play.google.com/store/apps/details?id=com.popopo.popopo",
} as const;
